import { render, staticRenderFns } from "./funcEditModal.vue?vue&type=template&id=1f3f6496"
import script from "./funcEditModal.vue?vue&type=script&lang=js"
export * from "./funcEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports